export function getAddressComponent(types, components) {
  for (let component of components) {
    for (let _type of component.types) {
      if (types.indexOf(_type) !== -1) {
        return component.long_name;
      }
    }
  }
}

export default class PlaceService {

    constructor(elemId) {
        const element = document.getElementById(elemId);

        this.placeService = new google.maps.places.PlacesService(element);
    }

    getPlace(token, placeId, callback) {
        let request = {
          placeId: placeId,
          fields: ['geometry', 'address_component'],
          sessionToken: token
        };

        this.placeService.getDetails(request, (placeResult, status) => {

            if (status === google.maps.places.PlacesServiceStatus.OK) {
                callback(placeResult);
            } else {
                // console.log(status);
            }
        });
    }
}
